const RANK_ALIASES = {
  resonant_pair: 'resonant_pair',
  'resonant pair': 'resonant_pair',
  '강한 공명형 조합': 'resonant_pair',
  '서로 강하게 끌리는 공명형 조합': 'resonant_pair',
  tension_pair: 'tension_pair',
  'tension pair': 'tension_pair',
  '텐션형 조합': 'tension_pair',
  '차이에서 끌림이 생기는 텐션형 조합': 'tension_pair',
  stable_match: 'stable_match',
  'stable match': 'stable_match',
  '안정형 조합': 'stable_match',
  '편안함이 먼저 읽히는 안정형 조합': 'stable_match',
  neutral_match: 'neutral_match',
  'neutral match': 'neutral_match',
  '중립형 조합': 'neutral_match',
  '차분하게 스며드는 중립형 조합': 'neutral_match',
};

export function getChemistryRankCode(result) {
  const candidates = [
    result?.rank_code,
    result?.rank,
    result?.result_label,
    result?.title,
  ];

  for (const candidate of candidates) {
    const normalized = String(candidate || '').trim().toLowerCase();
    if (RANK_ALIASES[normalized]) return RANK_ALIASES[normalized];
  }
  return 'unknown';
}

export function localizeChemistryResult(result, t) {
  if (!result) return result;
  const rankCode = getChemistryRankCode(result);
  const localizeApproachability = (value) => {
    if (!value) return value;
    const label = String(value.label || 'neutral').toLowerCase();
    return {
      ...value,
      text: t(`chemistry_result.approachability.${label}`, {
        defaultValue: t('chemistry_result.approachability.neutral'),
      }),
    };
  };

  return {
    ...result,
    rank_code: rankCode,
    title: t(`chemistry_result.ranks.${rankCode}.title`),
    desc: t(`chemistry_result.ranks.${rankCode}.description`),
    approachability: result.approachability ? {
      ...result.approachability,
      user_a: localizeApproachability(result.approachability.user_a),
      user_b: localizeApproachability(result.approachability.user_b),
    } : result.approachability,
  };
}
